import type { MeResponse } from '@/types/api';

export type AuthGate = 'ready' | 'primeiro-acesso' | 'escolher-escola';

export function resolveAuthGate(user: MeResponse | null): AuthGate {
  if (!user) return 'ready';

  if (user.primeiroAcesso || user.escolas.length === 0) {
    return 'primeiro-acesso';
  }

  if (user.idEscolaAtiva != null) {
    return 'ready';
  }

  if (user.escolas.length === 1) {
    return 'escolher-escola';
  }

  if (user.escolas.some((e) => e.principal)) {
    return 'escolher-escola';
  }

  return 'escolher-escola';
}

/** Escola que a tela ainda mostra, ou a unica/principal quando a sessao perdeu o contexto. */
export function idEscolaParaRestaurar(user: MeResponse | null): number | null {
  if (!user || user.primeiroAcesso || user.escolas.length === 0) return null;
  if (user.idEscolaAtiva != null) return user.idEscolaAtiva;
  if (user.escolas.length === 1) return user.escolas[0]!.id;
  return user.escolas.find((e) => e.principal)?.id ?? null;
}

export function getEscolaAtiva(user: MeResponse | null) {
  if (!user?.idEscolaAtiva) return null;
  return user.escolas.find((e) => e.id === user.idEscolaAtiva) ?? null;
}

export async function ensureEscolaAtiva(
  user: MeResponse,
  selecionar: (idEscola: number) => Promise<void>,
): Promise<void> {
  if (user.idEscolaAtiva != null) return;
  if (user.escolas.length === 1) {
    await selecionar(user.escolas[0]!.id);
    return;
  }
  const principal = user.escolas.find((e) => e.principal);
  if (principal) {
    await selecionar(principal.id);
  }
}
